// extracted by mini-css-extract-plugin
export var active = "_2q-b";
export var activeIndicator = "_2q-6";
export var animate = "_2q-a";
export var disabled = "_2q-c";
export var flat = "_2q-1";
export var fullWidth = "_2q-3";
export var lg = "_2q-9";
export var md = "_2q-8";
export var redoButtonTabGroup = "_2q-0";
export var sm = "_2q-7";
export var tabButton = "_2q-4";
export var tabButtonsContainer = "_2q-2";
export var xs = "_2q-5";